<template>
  <div
      style="width: 100%!important;"
    class="btn-toolbar"
    role="toolbar"
    aria-label="Toolbar with button groups"
  >
    <div class="btn-group btn-group-toggle btn-block" role="group">
      &nbsp;
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="_pickedDateDWM('day')"
        v-bind:class="[pickedDateDWM === 'day' ? 'active' : '']"
      >
        Daily
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="_pickedDateDWM('week')"
        v-bind:class="[pickedDateDWM === 'week' ? 'active' : '']"
      >
        Weekly
      </button>
      <button
        type="button"
        class="btn btn-candle"
        v-on:click="_pickedDateDWM('month')"
        v-bind:class="[pickedDateDWM === 'month' ? 'active' : '']"
      >
        Monthly
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PeriodsIndep",
  data() {
    return { pickedDateDWM: "day" };
  },
  methods: {
    _pickedDateDWM(interval) {
      this.pickedDateDWM = interval;
      this.$emit("eventOnChangeDWM", this.pickedDateDWM);
    }
  }
};
</script>
